module.exports = __webpack_public_path__ + "img/stakewise-purple.66546c21.svg";